<template>
  <div>
    <v-card>
      <b-form-group
        center
        id="FechaInicio"
        label="Fecha Inicio"
        label-for="FechaInicio"
        class="mx-auto"
      >
        <b-form-input autocomplete="off" id="FechaInicio" type="date" v-model="filtro.FechaInicio"></b-form-input>
      </b-form-group>

      <b-form-group center id="FechaFin" label="Fecha Fin" label-for="FechaFin" class="mx-auto">
        <b-form-input autocomplete="off" id="FechaFin" type="date" v-model="filtro.FechaFin"></b-form-input>
      </b-form-group>

      <b-row></b-row>
      <b-row></b-row>
      <b-row>
        <div class="mx-auto">
          <b-button variant="primary" @click="$emit('buscar')">Buscar</b-button>
        </div>
      </b-row>
    </v-card>
  </div>
</template>


<script>
export default {
  name: "ServiceFilter",
  components: {},
  props: {
    filtro: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

